/* __next_internal_client_entry_do_not_use__ ProductLinkForSDUIEvaluateTile auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { useOnProductClickBase } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useOnProductClickBase";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
export var ProductLinkForSDUIEvaluateTile = function(param) {
    var productToken = param.productToken, productUrl = param.productUrl, productTile = param.productTile, children = param.children;
    var _productTile_product, _productTile_product1, _productTile_product2;
    var _productTile_product_impression_id, _productTile_product_promoted_by;
    var onProductClick = useOnProductClickBase({
        token: (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token,
        bestImage: productTile.best_image,
        images: productTile.images,
        impressionId: (_productTile_product_impression_id = (_productTile_product1 = productTile.product) === null || _productTile_product1 === void 0 ? void 0 : _productTile_product1.impression_id) !== null && _productTile_product_impression_id !== void 0 ? _productTile_product_impression_id : "",
        promotedBy: (_productTile_product_promoted_by = (_productTile_product2 = productTile.product) === null || _productTile_product2 === void 0 ? void 0 : _productTile_product2.promoted_by) !== null && _productTile_product_promoted_by !== void 0 ? _productTile_product_promoted_by : []
    });
    return /*#__PURE__*/ _jsx(ProductLink, {
        onClick: onProductClick,
        "data-test-id": "product-tile-link-".concat(productToken),
        to: productUrl !== null && productUrl !== void 0 ? productUrl : "",
        children: children
    });
};
var ProductLink = styled(Link).withConfig({
    componentId: "sc-8f9755d6-0"
})([
    "flex:1;display:flex;flex-direction:column;position:relative;"
]);
